// import library
import axios from "axios";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
// import component
import Layout from "../../layouts/Layout";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
import AgreementFormPopUpComponent from "../../components/Profile/AgreementFormPopUpComponent";
// files
import { env } from "../../env";
import LoaderIcon from "../../components/Common/Icon/Loader";
import WarningPopUp from "../../components/Profile/WarningPopUp";
import { AuthContext } from "../../context";

const CreateAgreement = () => {
    // variables
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const customerid = location.pathname.split('/')[3];
    const storedVisitData = localStorage.getItem('visit');
    const initialVisitData = storedVisitData ? JSON.parse(storedVisitData) : {};
    const [visitTypeData, setVisitTypeData] = useState(initialVisitData);
    const [showWarningPopUp, setShowWarningPopUp] = useState(false);
    
    const [sortTypesList, setSortTypesList] = useState([
        {
            "name" : "name - top to bottom",
            "field" : "name",
            "type" : "asc"
        },
        {
            "name" : "name - bottom to top",
            "field" : "name",
            "type" : "desc"
        },
    ]);

    const [showSort, setShowSort] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);
    const [isLoader, setIsLoader] = useState(true);
    const [isFormLoader, setIsFormLoader] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [sortType, setSortType] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortName, setSortName] = useState("");

    const [headerList, setHeaderList] = useState([]);
    const [headerDetail, setHeaderDetail] = useState({});
    const [headerListDetail, setHeaderListDetail] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');

            getHeaderListApi(baseUrl, token);
        };
        fetchData();
    }, []);

    // tab change
    const handleTabCheckDataFromChild = (data) => {
        if((visitTypeData && visitTypeData.visitId) && data.tab === 'profile') {
            setShowWarningPopUp(!showWarningPopUp)
        } else {
            if(data.link === '/logout') {
                authContext.logout();
            } else {
                navigate(data.link);
            }
            localStorage.removeItem("profile_tab");
        }
    };
    const handleWarningPopUpDataFromChild = (data) => {
        setShowWarningPopUp(!showWarningPopUp);
        if(data === 'complete') {
            setVisitTypeData({});
        }
    };
    // function 
    const getHeaderListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/CustomerDetails/GetContractHeaderList?customerid=${customerid}`,{ headers })
        .then((response) => {
            setHeaderList(response.data);
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            setIsLoader(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getHeaderDetailApi = async(url, token, id) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/CustomerDetails/GetContractDetailListByHeaderId?headerid=${id}`,{ headers })
        .then((response) => {
            setHeaderDetail(response.data);
            setIsFormLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    // const handleSearch = (e) => {
    //     e.preventDefault();
    // };
    // const handleShowSort = (e) => {
    //     e.preventDefault();
    //     setShowSort(!showSort);
    // };
    // const handleShowFilter = (e) => {
    //     e.preventDefault();
    //     setShowFilter(!showFilter);
    // };
    // const handleSortType = (e, data) => {
    //     e.preventDefault();
    //     setSortName(data.name);
    // };
    const handleModalCloseDataFromChild = (data) => {
        setShowPopUp(data);
    };
    const handleNewAgreement = (e, header) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setShowPopUp(true);
        setIsFormLoader(true);
        getHeaderDetailApi(baseUrl, token, header.Id);
        setHeaderListDetail(header);
    };
    
    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}>
                <div className="flex justify-between items-center">
                    <div className="w-44 sm:w-auto">
                        <h1 className="text-sm sm:text-2xl font-semibold capitalize">{ t('enrol to new agreements') }</h1>
                        <div className="text-light-400 text-[10px] w-max sm:w-auto sm:text-sm capitalize flex items-center cursor-pointer"><NavLink to={`/profiles/detail/${customerid}`}>{ t('customer detail') }</NavLink> / { t('new agreement') }</div>
                    </div>
                    <div className="flex justify-between items-center space-x-1 sm:space-x-2">
                        {/* <div className="border border-gray-dark1 cursor-pointer bg-white rounded-lg hidden sm:flex items-center px-4 py-2">
                            <img className="w-4" src="../../../assets/icons/search.svg" alt="search" />
                            <div className="pl-4">
                                <input className="border-none bg-white focus:outline-none w-44 sm:w-32 lg:w-80 placeholder:capitalize" type="text" onKeyDown={(e) => handleSearch(e)} onKeyPress={(e) => handleSearch(e)} placeholder={t('search')+"..."} />
                            </div>
                        </div> */}
                        <div className="flex items-center justify-end space-x-1 sm:space-x-2">
                            <div className="block sm:hidden">
                                <NavLink to={`/profiles/detail/${customerid}`}>
                                    <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                                        <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div className="hidden sm:block">
                        <NavLink to={`/profiles/detail/${customerid}`}>
                            <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                                <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                            </div>
                        </NavLink>
                    </div>
                </div>
                {/* <div className="block sm:hidden bg-white p-2 rounded-lg">
                    <div className="border border-gray-dark1 cursor-pointer bg-white rounded-lg flex items-center py-2 px-2 sm:px-4">
                        <img className="w-4" src="../../../assets/icons/search.svg" alt="search" />
                        <div className="pl-4">
                            <input className="border-none bg-white focus:outline-none w-44 sm:w-32 lg:w-80 placeholder:capitalize" type="text" onKeyDown={(e) => handleSearch(e)} onKeyPress={(e) => handleSearch(e)} placeholder={t('search')+"..."} />
                        </div>
                    </div>
                </div> */}
                { isLoader
                    ?
                        <LoaderIcon />
                    :
                        <div className={((headerList.length > 0) ? "grid lg:grid-cols-2 xl:grid-cols-3 gap-2 sm:gap-4" : "" )}>
                            { 
                                headerList.length > 0 ? 
                                    headerList.map((header, index) => (
                                        <div key={`header${header.Id}`} className="rounded-xl bg-white flex justify-between items-center p-3 sm:p-4 cursor-pointer">
                                            <div className="xl:col-span-2 flex flex-col justify-between space-y-2">
                                                <h1 className="font-semibold text-sm sm:text-base capitalize">{header.Contract_Title}</h1>
                                                <div className="first-letter:capitalize text-xs">
                                                    {header.Contract_Description}
                                                </div>
                                            </div>
                                            <img onClick={(e) => handleNewAgreement(e, header)} className="cursor-pointer" src="../../../assets/icons/profile/plus_light.svg" alt="plus_light" />
                                        </div>
                                    ))
                                : 
                                    <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white">
                                        { t('no data available')}
                                    </div>
                            }
                        </div>
                }
            </Layout>
            {/* page */}
            {showPopUp &&
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                    <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="absolute sm:relative bottom-0 sm:bottom-auto sm:inline-block align-center bg-white rounded-t-xl sm:rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-middle max-w-lg sm:max-w-xl w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            {isFormLoader
                                ?
                                    <LoaderIcon />
                                :
                                    <AgreementFormPopUpComponent customerId={customerid} sendModalCloseDataFromChild={handleModalCloseDataFromChild} headerDetail={headerDetail} headerListDetail={headerListDetail} />
                            }
                        </div>
                    </div>
                </div>
            }
            {/* common */}
            {showWarningPopUp && <WarningPopUp customerId={customerid} visitTypeData={visitTypeData} sendWarningPopUpDataFromChild={handleWarningPopUpDataFromChild} /> }
        </div>
    )
}

export default CreateAgreement;